/**
 * 画面スクロール位置情報
 */
export class ScrollPositionInfo {
	// private変数 --------------------------------------------------------
	private m_Id: string = null; // id属性
	// --------------------------------------------------------------------

	// プロパティ --------------------------------------------------------------------
	/** id */
	public get id(): string { return this.m_Id; } public set id(id: string) { this.m_Id = id; }
	// --------------------------------------------------------------------

	// コンストラクタ --------------------------------------------------------
	constructor() { }
	// ----------------------------------------------------------------------
}